import React from "react";
import { BadgeCheck } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

/**
 * VerifiedSellerBadge — shows that a seller has completed identity
 * verification (Stripe Connect KYC). Use `compact` on dense surfaces
 * (e.g. auction cards), and the default size elsewhere.
 */
export const VerifiedSellerBadge = ({ verified, compact = false, label = "Verified", className = "" }) => {
    if (!verified) return null;
    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        data-testid="verified-seller-badge"
                        className={`inline-flex items-center gap-1 rounded-full border border-electric/30 bg-electric/10 font-medium text-electric ${compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"} ${className}`}
                    >
                        <BadgeCheck className={compact ? "h-3 w-3" : "h-3.5 w-3.5"} aria-hidden />
                        {label}
                    </span>
                </TooltipTrigger>
                <TooltipContent>
                    Identity verified via Stripe Connect (KYC)
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
